import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { Coupon, CouponDetailsVariables } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<CouponDetailsVariables, null>) {
  const { variables } = params;

  const {
    locator,
    ccl,
    cco,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  let search: Record<string, string | number | undefined> = {
    cid,
    uid,
  };
  if (ccl) {
    search = {
      ...search,

      ccl,
    };
  }
  if (cco) {
    search = {
      ...search,

      cco,
    };
  }

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Coupon/GetCouponDetails${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<CouponDetailsVariables, null>({
  schema,
  dataPath: 'user:customer:get_coupon_details',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  CouponDetailsVariables,
  null,
  Coupon,
  Coupon[],
  Coupon[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,

  keySelector: coupon => coupon.id,
  processorFn: response => response,
});
